<template lang='pug'>
  ol.breadcrumb
    li.breadcrumb-item(v-for='(item, index) in list')
      span.active(v-if='isLast(index)') {{ showName(item) }}
      router-link(:to='item', v-else='') {{ showName(item) }}
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue